import { useContext, useState } from 'react'

import { EditContext } from 'Components/Hooks/ContextEdit'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import ComplexDialog from 'Components/UI/Molecules/ComplexDialog'
import ComplexDialogActions from 'Components/UI/Molecules/ComplexDialog/Actions'
import ComplexDialogHistory from 'Components/UI/Molecules/ComplexDialogHistory'
import { SUCURSAL_ORIGEN } from 'Constants'

import CajaData from './CajaData'
import Expenses from './Expenses'

const Edit = (props) => {
  const { open, handleclose, data, setRender, render, setLoading, dataBefore } = props

  const createDismissableSnackbar = useCustomSnackbar()
  const [edit] = useContext(EditContext)

  const [dataInfo, setDataInfo] = useState(data)

  const origenLabel = SUCURSAL_ORIGEN.find((sucursal) => sucursal.id === data.cajaInfo.origen).label

  const handleSubmit = () => {
    setLoading(true)
    setTimeout(() => {
      createDismissableSnackbar('Cambios guardados con éxito', {
        variant: 'success',
      })
      setRender(!render)
      handleclose()
      setLoading(false)
    }, 500)
  }

  const horizontalTabs = [
    {
      id: 0,
      title: 'Caja',
      color: 'primary',
    },
    {
      id: 1,
      title: 'Gastos',
      color: 'primary',
    },
    {
      id: 2,
      title: 'Historial',
      color: 'primary',
    },
  ]

  const renderTabs = (index) => {
    switch (index) {
      case 0:
        return (
          <CajaData
            data={dataInfo}
            edit={edit}
            setRender={setRender}
            render={render}
            setData={setDataInfo}
            closeCancel={handleclose}
            origen={origenLabel}
          />
        )
      case 1:
        return (
          <Expenses
            data={dataInfo}
            edit={edit}
            setRender={setRender}
            render={render}
            dataBefore={dataBefore}
            setData={setDataInfo}
            closeCancel={handleclose}
          />
        )
      case 2:
        return <ComplexDialogHistory history={dataInfo.historial} />
      default:
        break
    }
  }

  return (
    <>
      <ComplexDialog
        open={open}
        onClose={handleclose}
        tabs={horizontalTabs}
        title={
          <>
            {`Caja del día ${dataInfo.cajaInfo.fecha}`}
            {dataInfo.recibos.length > 0 && (
              <span
                style={{
                  color: '#3182a9',
                  fontWeight: 'revert',
                  fontSize: '1rem',
                  backgroundColor: '#d9edf7',
                  borderRadius: '.5rem',
                  padding: '.4rem',
                  marginLeft: '1rem',
                }}
              >
                {`Existen recibos en estado borrador!`}
              </span>
            )}
          </>
        }
        subtitle={
          <div>
            {`Creado el ${dataInfo.cajaInfo.fecha} por ${
              dataBefore?.data.usuarios?.find((u) => u.id === dataInfo?.cajaInfo?.usuario)
                ?.fullName || 'Usuario desconocido'
            }`}
          </div>
        }
        children={renderTabs}
        actions={
          <ComplexDialogActions
            onClose={handleclose}
            handleSubmit={() => handleSubmit()}
            canEdit={dataBefore.data.permissions.ECO.adminCaja ? dataInfo.canEdit : true}
            data={dataInfo}
            editMode={true}
          />
        }
      />
    </>
  )
}

export default Edit
